export class GlobalConstants {
  public static apiURL: string = process.env.VUE_APP_SERVER_ADDRESS || 'http://127.0.0.1:3000';
}
